import { render, staticRenderFns } from "./UsuarioFornecedorFiltros.vue?vue&type=template&id=03d45aed"
import script from "./UsuarioFornecedorFiltros.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorFiltros.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorFiltros.vue?vue&type=style&index=0&id=03d45aed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports